export const PortalListLayoutViewerPageSize = 100;